import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  maxAvailableQuantity: number
}

const MaxAvailableError = ({ maxAvailableQuantity }: Props) => {
  const { translate } = useTranslations()

  const errorText =
    maxAvailableQuantity > 0
      ? translate('Cart_MaxQuantity_TooManyError', { quantity: maxAvailableQuantity.toString() })
      : translate('Cart_MaxQuantity_NotAvailableError')

  return (
    <div className="u-flex-basis-100 u-flex-basis-lg-80">
      <p className="u-fs-14 u-color-danger">{errorText}</p>
    </div>
  )
}

export default MaxAvailableError
